export const MODAL_VARIANT_TYPE = {
  DEFAULT: 'default',
  CHILDCARE_LOCATION: 'childCareLocation',
  PET_CARE: 'petCare',
  SENIOR_CARE: 'seniorCare',
} as const;

export type ModalVariant = (typeof MODAL_VARIANT_TYPE)[keyof typeof MODAL_VARIANT_TYPE];
